import http from "../http";
import Service from "../../Service";

export default class ProfileManagementService extends Service {
    list(params = {}) {
        return http.get("/v2/admin/profiles", {
            headers: this.getHeaders(),
            params,
        });
    }

    updateVisibility(id, visibility) {
        return http.patch(
            `/v2/admin/profiles/${id}/visibility`,
            { visibility },
            {
                headers: this.getHeaders(),
            }
        );
    }

    update(id, data) {
        return http.put(`/v2/admin/profiles/${id}`, data, {
            headers: this.getHeaders(),
        });
    }

    togglePermission(id, permissionId, enabled) {
        return http.patch(
            `/v2/admin/profiles/${id}/permissions/${permissionId}/toggle`,
            { enabled },
            {
                headers: this.getHeaders(),
            }
        );
    }

    remove(id) {
        return http.delete(`/v2/admin/profiles/${id}`, {
            headers: this.getHeaders(),
        });
    }
}
